import React, { useState } from "react";
import Input from "components/input";
import useForm from "hooks/form";
import { shopAPIUrl } from "../../utils/constants";
import { sendMetaEvent } from "../../helpers/send-event";

const AutomaticSignUp = () => {
    const [data, setData] = useState();
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(true);
    const apiURL = `${shopAPIUrl}/users/signUpFromNewsletter`;

    async function onSubmit(form) {
        if (form.password !== form.confirmPassword) {
            setError("Passwords do not match!");
            return { loading: false, success: false, failure: false, mismatch: true };
        }

        try {
            const response = await fetch(apiURL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    type: "web", 
                    email: form.email,
                    firstName: form.firstName,
                    lastName: form.lastName,
                    password: form.password
                }),
            }).then(res => res.json()).then(res => {
                if (res.message !== "Email already exists.") {
                    const userId = res.userId ? { "external_id": [res.userId] } : {};
                    const origin = window.location.origin + window.location.pathname;
                    sendMetaEvent("Lead", origin, {
                        "user_data": {
                            em: form.email,
                            fn: form.firstName,
                            ln: form.lastName,
                            ...userId
                        },
                        "custom_data": {
                            "source": "web"
                        }
                    })
                }

                return res
            });
    
            setData(response);
            setError(null);
            return { success: true };
        } catch (error) {
            setError("Failed to register. Please try again.");
            return { success: false };
        }
    }

    const { form, handleChange, handleSubmit, states: { loading, success, failure } } = useForm(
        {
            email: "",
            firstName: "",
            lastName: "",
            password: "",
            confirmPassword: "",
        },
        onSubmit
    );

    if (loading) {
        return <p className="text-center text-gray-700">Saving registration information ...</p>
    }

    if (success && data?.message == 'Email already exists.') {
        return <p className="text-center text-gray-700">There is already a MyStables account registered with this email address. Please log in to <a href='https://mystables.oldgoldracing.com' className="text-green-700 underline">here</a> to see updates on the club horse.</p>
    }

    if (failure) {
        return <p className="text-center text-gray-700"> Something went wrong, please try again ... </p>
    }

    return (
        <>
            <div className="relative hidden flex-col w-full sm:flex" onClick={() => setOpen(prevState => !prevState)}>
                <div className="w-28 h-1.5 bg-gray-400 mx-auto rounded-xl" />
                <h3 className={`text-2xl font-bold font-display text-yellow-400 text-center ${open ? "mb-4" : "mb-0"} mt-2.5`}>
                    {success ? "Verify your email" : "Join the club"}
                </h3>
                <button className={`text-xs font-sans font-semibold underline text-gray-900 absolute top-0 right-0 ${open ? "block" : "hidden"}`}>Close</button>
            </div>
            <h3 className="text-2xl font-bold font-display text-yellow-400 mb-4 text-center block sm:hidden">
                {success ? "Verify your email" : "Join the club"}
            </h3>
            {success 
                ? (
                    <div className={`${open ? "sm:flex" : "sm:hidden"} flex flex-col items-center text-center text-gray-700 gap-4`}>
                        <p>To ensure that your account is secure, we have sent you a link to verify your email address.</p>
                        <p>Please check your inbox and click the link to verify your account.</p>
                        <p>If the email isn't in your main inbox, please check your spam or junk folders.</p>
                    </div>
                ) 
                : (
                    <form onChange={handleChange} onSubmit={handleSubmit} className={`${open ? "sm:block" : "sm:hidden"} block`}>
                        <Input defaultValue={form.firstName} placeholder="First Name" name="firstName" type="text" required />
                        <Input defaultValue={form.lastName} placeholder="Last Name" name="lastName" type="text" required />
                        <Input defaultValue={form.email} placeholder="Email Address" name="email" type="email" required />
                        <Input defaultValue={form.password} placeholder="Create password" name="password" type="password" required />
                        <Input defaultValue={form.confirmPassword} placeholder="Confirm Password" name="confirmPassword" type="password" required />
                        {error && <p className="text-sm text-red-500 mt-2">{error}</p>}
                        <button 
                            type="submit" 
                            className="btn btn-primary w-full my-4"
                        >
                            Create Account
                        </button>
                    </form>
                )
            }
        </>
    );
}

export default AutomaticSignUp;